export default "__VITE_ASSET__Bs5Tu83Z__"